/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */

/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */

// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript'
// @ts-ignore
// prettier-ignore
import type { RequestConfig, RequestFunctionRestArgs } from 'yapi-to-typescript'
// @ts-ignore
import request from '../../request';

type UserRequestRestArgs = RequestFunctionRestArgs<typeof request>;

// Request: 目前 React Hooks 功能有用到
export type Request<
  TRequestData,
  TRequestConfig extends RequestConfig,
  TRequestResult
> = (TRequestConfig['requestDataOptional'] extends true
  ? (requestData?: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult
  : (requestData: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult) & {
  requestConfig: TRequestConfig;
};

const mockUrl_0_0_0_0 = 'http://10.50.16.213:40001/mock/283' as any;
const devUrl_0_0_0_0 = '' as any;
const prodUrl_0_0_0_0 = 'http://127.0.0.1' as any;
const dataKey_0_0_0_0 = 'retdata' as any;

/**
 * @分类 [mock规则管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2005)
 * @请求头 `POST /api/data-rule/{id}/copy`
 */
export interface IdCopyPostRequest {
  /**
   * 被复制规则id
   */
  id: string;
}

/**
 * @分类 [mock规则管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2005)
 * @请求头 `POST /api/data-rule/{id}/copy`
 */
export type IdCopyPostResponse = number;

/**
 * @分类 [mock规则管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2005)
 * @请求头 `POST /api/data-rule/{id}/copy`
 */
type ApiDataRuleIdCopyPostRequestConfig = Readonly<
  RequestConfig<
    'http://10.50.16.213:40001/mock/283',
    '',
    'http://127.0.0.1',
    '/api/data-rule/{id}/copy',
    'retdata',
    'id',
    string,
    false
  >
>;

/**
 * @分类 [mock规则管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2005)
 * @请求头 `POST /api/data-rule/{id}/copy`
 */
const apiDataRuleIdCopyPostRequestConfig: ApiDataRuleIdCopyPostRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/api/data-rule/{id}/copy',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.none,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: ['id'],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'apiDataRuleIdCopyPost',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * @分类 [mock规则管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2005)
 * @请求头 `POST /api/data-rule/{id}/copy`
 */
export const apiDataRuleIdCopyPost = /*#__PURE__*/ (requestData: IdCopyPostRequest, ...args: UserRequestRestArgs) => {
  return request<IdCopyPostResponse>(prepare(apiDataRuleIdCopyPostRequestConfig, requestData), ...args);
};

apiDataRuleIdCopyPost.requestConfig = apiDataRuleIdCopyPostRequestConfig;

/* prettier-ignore-end */
